import { render, staticRenderFns } from "./ConsentGroup.vue?vue&type=template&id=17dd55ea&scoped=true&"
import script from "./ConsentGroup.vue?vue&type=script&lang=js&"
export * from "./ConsentGroup.vue?vue&type=script&lang=js&"
import style0 from "./ConsentGroup.vue?vue&type=style&index=0&id=17dd55ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd55ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
